(function (angular) {
    'use strict';

    angular.module('dashboard')

        .component('dashboardLiveChat', {
            bindings: {
                teams: "<"
            },
            controller: ["liveChatService", "permissionService", function (liveChatService, permissionService) {
                var ctrl = this;

                ctrl.ctaMessage = "";


                ctrl.teamStats = [];

                /**
                 * 
                 */
                ctrl.updateData = function (data) {
                    ctrl.teamStats = data.team;
                }

                var listenerFunc = ctrl.updateData.bind(this);

                /**
                 * 
                 */
                ctrl.$onInit = function () {
                    ctrl.hasContact = permissionService.checkPermission("package:contact");

                    liveChatService.addEventListener(listenerFunc);
                }

                /**
                 * 
                 */
                ctrl.$onDestroy = function () {
                    liveChatService.removeEventListener(listenerFunc);
                }

                ctrl.$onChanges = function (changes) {
                    if (changes.teams.currentValue) {
                        ctrl.teams = changes.teams.currentValue;
                    }
                }
            }],
            templateUrl: "components/dashboard/templates/liveChatComponent.html"
        })

})(window.angular);